import React from 'react';
import BasicDrawer from '../../components/Drawer';
import Circular from '../../components/Loader/Circular';
import { Avatar, Col, Divider, Row } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import BasicText from '../../components/Text/BasicText';
import { Colors } from '../../config';
import moment from 'moment';
import { Button, Text } from '../../components';
import { CiEdit } from 'react-icons/ci';
import useColors from '../../hooks/useColors';

const UserDetailDrawer = ({
    drawerStates,
    onCloseDrawer,
    detailDrawerReset,
    userDetailLoader,
    userDetailData,
    UserEditHandler,
    isRole,
    hideEditButton,
}) => {
    const { colorPrimary } = useColors();
    const formatCertificationDate = (dateVal) => {
        if (!dateVal) return '-';
        const parsed = moment(dateVal, ['DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601]);
        return parsed.isValid() ? parsed.format('DD-MM-YYYY') : '-';
    };
    console.log(userDetailData, 'isRole in detail drawer');

    return (
        <BasicDrawer
            openDrawer={drawerStates?.userDetailDrawer}
            title={'User Details'}
            onClose={onCloseDrawer}
            afterOpenChange={detailDrawerReset}
            width={'600'}
        >
            {userDetailLoader ? (
                <Circular
                    spinning={userDetailLoader}
                    size={40}
                    color={colorPrimary}
                    containerStyle={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                />
            ) : (
                <Row className="w-full">
                    <Col
                        className="w-full flex flex-col items-center"
                        span={24}
                    >
                        {userDetailData?.profileImg ? (
                            <Avatar
                                size={55}
                                src={userDetailData?.profileImg[0]?.url}
                            />
                        ) : (
                            <Avatar size={55} icon={<UserOutlined />} />
                        )}
                        <BasicText
                            className="text-xl font-semibold text-center"
                            text={
                                userDetailData?.userName
                                    ? userDetailData?.userName
                                    : '-'
                            }
                        />
                        <span>
                            {userDetailData?.userRole
                                ? userDetailData?.userRole[0]?.name
                                : '-'}
                        </span>
                    </Col>

                    <Divider />

                    <Row className="w-full" justify={'center'} align={'middle'}>
                        <Col span={9} className="w-2/4 flex flex-col">
                            <span
                                className="text-sm font-semibold"
                                style={{ color: Colors.LabelColor }}
                            >
                                First Name
                            </span>
                            <BasicText
                                className="text-sm font-medium"
                                text={
                                    userDetailData?.firstName
                                        ? userDetailData?.firstName
                                        : '-'
                                }
                            />
                        </Col>

                        <Col span={9} className="w-2/4 flex flex-col">
                            <span
                                className="text-sm font-semibold"
                                style={{ color: Colors.LabelColor }}
                            >
                                Last Name
                            </span>
                            <BasicText
                                className="text-sm font-medium"
                                text={
                                    userDetailData?.lastName
                                        ? userDetailData?.lastName
                                        : '-'
                                }
                            />
                        </Col>

                        <Col span={6} className="w-2/4 flex flex-col">
                            <span
                                className="text-sm font-semibold"
                                style={{ color: Colors.LabelColor }}
                            >
                                Role
                            </span>
                            <div className="flex items-center justify-start gap-1 flex-wrap">
                                {userDetailData?.userRole?.map((role, key) => {
                                    return (
                                        <>
                                            <BasicText
                                                key={role?.id}
                                                className="text-sm font-medium"
                                                text={role?.name}
                                            />
                                        </>
                                    );
                                })}
                            </div>
                        </Col>
                    </Row>

                    <Divider />

                    <Row className="w-full" justify={'center'} align={'start'}>
                        <Col span={9} className="w-2/4 flex flex-col">
                            <span
                                className="text-sm font-semibold"
                                style={{ color: Colors.LabelColor }}
                            >
                                Phone Number
                            </span>
                            <BasicText
                                className="text-sm font-medium"
                                text={
                                    userDetailData?.phoneNo
                                        ? userDetailData?.phoneNo
                                        : '-'
                                }
                            />
                        </Col>

                        <Col span={9} className="w-2/4 flex flex-col">
                            <span
                                className="text-sm font-semibold"
                                style={{ color: Colors.LabelColor }}
                            >
                                Email
                            </span>
                            <BasicText
                                className="text-sm font-medium break-words"
                                text={
                                    userDetailData?.email
                                        ? userDetailData?.email
                                        : '-'
                                }
                            />
                        </Col>

                        <Col span={6} className="w-2/4 flex flex-col">
                            <span
                                className="text-sm font-semibold"
                                style={{ color: Colors.LabelColor }}
                            >
                                User Name
                            </span>
                            <BasicText
                                className="text-sm font-medium"
                                text={
                                    userDetailData?.userName
                                        ? userDetailData?.userName
                                        : '-'
                                }
                            />
                        </Col>
                    </Row>

                    <Divider />

                    <Row className="w-full" justify={'center'} align={'middle'}>
                        <Col span={24} className="flex flex-col">
                            <span
                                className="text-sm font-semibold"
                                style={{ color: Colors.LabelColor }}
                            >
                                Position
                            </span>
                            <div className="flex items-center justify-start gap-1 flex-wrap">
                                {userDetailData?.eligibilities?.map(
                                    (eligibility, key) => {
                                        return (
                                            <>
                                                <BasicText
                                                    key={eligibility?.id}
                                                    className="text-sm font-medium"
                                                    text={eligibility?.name}
                                                />
                                                {key <
                                                    userDetailData
                                                        ?.eligibilities
                                                        ?.length -
                                                        1 && <span>,</span>}
                                            </>
                                        );
                                    },
                                )}
                            </div>
                        </Col>
                    </Row>

                    <Divider />

                    <Row className="w-full" justify={'start'} align={'start'}>
                        <Col span={9} className="flex flex-col">
                            <span
                                className="text-sm font-semibold"
                                style={{ color: Colors.LabelColor }}
                            >
                                Schedules
                            </span>
                            <div className="flex items-center justify-start gap-1 flex-wrap">
                                {userDetailData?.schedules?.map(
                                    (schedule, key) => {
                                        return (
                                            <>
                                                <BasicText
                                                    key={schedule?.id}
                                                    className="text-sm font-medium"
                                                    text={schedule?.name}
                                                />
                                                {key <
                                                    userDetailData?.schedules
                                                        ?.length -
                                                        1 && <span>,</span>}
                                            </>
                                        );
                                    },
                                )}
                            </div>
                        </Col>

                        <Col span={9} className="flex flex-col">
                            <span
                                className="text-sm font-semibold"
                                style={{ color: Colors.LabelColor }}
                            >
                                Created Date
                            </span>
                            <BasicText
                                className="text-sm font-medium"
                                text={
                                    (userDetailData?.createdAt || userDetailData?.schedules?.[0]?.createdAt)
                                        ? moment(userDetailData?.createdAt || userDetailData?.schedules?.[0]?.createdAt).format('MMMM DD, YYYY')
                                        : '-'
                                }
                            />
                        </Col>
                    </Row>

                    <Divider />

                    {isRole == 'guard' && (
                        <BasicText
                            className="w-full mb-5 text-base font-semibold"
                            text={'Certification Info:'}
                        />
                    )}

                    {/* {userDetailData?.certificateInfo && (<Row className='w-full' justify={'center'} align={'middle'}>
                            <Col span={9} className='flex flex-col'>
                                <span className='text-sm font-semibold' style={{ color: Colors.LabelColor }}>Unarmed expiration:</span>
                                <BasicText className='text-sm font-medium' text={userDetailData?.certificateInfo?.unarmedExpiration ? moment(userDetailData?.certificateInfo?.unarmedExpiration).format('DD-MM-YYYY') : '-'} />
                            </Col>

                            <Col span={15} className='flex flex-col'>
                                <span className='text-sm font-semibold' style={{ color: Colors.LabelColor }}>Armed expiration:</span>
                                <BasicText className='text-sm font-medium' text={userDetailData?.certificateInfo?.armedExpiration ? moment(userDetailData?.certificateInfo?.armedExpiration).format('DD-MM-YYYY') : '-'} />
                            </Col>

                            <Col span={6} className='flex flex-col'>
                                <span className='text-sm font-semibold' style={{ color: Colors.LabelColor }}>OJT:</span>
                                <BasicText className='text-sm font-medium' text={userDetailData?.certificateInfo?.ojt ? moment(userDetailData?.certificateInfo?.ojt).format('DD-MM-YYYY') : '-'} />
                            </Col>
                        </Row>)} */}

                    {/* {userDetailData?.certificateInfo && (<Row className='w-full' justify={'start'} align={'middle'}>
                            <Col span={9} className='flex flex-col'>
                                <span className='text-sm font-semibold' style={{ color: Colors.LabelColor }}>8-Hour Annual In-Service-1:</span>
                                <BasicText className='text-sm font-medium' text={userDetailData?.certificateInfo?.annualOne ? moment(userDetailData?.certificateInfo?.annualOne).format('DD-MM-YYYY') : '-'} />
                            </Col>

                            <Col span={15} className='flex flex-col'>
                                <span className='text-sm font-semibold' style={{ color: Colors.LabelColor }}>8-Hour Annual In-Service-2:</span>
                                <BasicText className='text-sm font-medium' text={userDetailData?.certificateInfo?.annualTwo ? moment(userDetailData?.certificateInfo?.annualTwo).format('DD-MM-YYYY') : '-'} />
                            </Col>
                        </Row>)} */}

                    {/* Dynamic Certifications Display */}
                    {/* Dynamic Certifications Display */}

                    {userDetailData?.certificateInfo?.certifications && (
                        <>
                            <Text.Basic
                                className="w-full my-3"
                                style={{
                                    textAlign: 'left',
                                    fontSize: '1rem',
                                    fontWeight: '500',
                                    paddingLeft: '2px',
                                }}
                                text={'Certification info:'}
                            />
                            <Row
                                className="w-full mt-2"
                                justify={'start'}
                                align={'middle'}
                                gutter={[16, 16]}
                            >
                                {Array.isArray(
                                    userDetailData.certificateInfo
                                        .certifications,
                                )
                                    ? userDetailData.certificateInfo.certifications.map(
                                          (item, index) => (
                                              <Col
                                                  span={12}
                                                  key={index}
                                                  className="flex flex-col"
                                              >
                                                  <span
                                                      className="text-sm font-semibold"
                                                      style={{
                                                          color: Colors.LabelColor,
                                                       }}
                                                  >
                                                      {item.name}:
                                                  </span>
                                                  <BasicText
                                                      className="text-sm font-medium"
                                                      text={formatCertificationDate(item.expiration)}
                                                  />
                                              </Col>
                                          ),
                                      )
                                    : Object.entries(
                                          userDetailData.certificateInfo
                                              .certifications,
                                      ).map(([key, value]) => (
                                          <Col
                                              span={12}
                                              key={key}
                                              className="flex flex-col"
                                          >
                                              <span
                                                  className="text-sm font-semibold"
                                                  style={{
                                                      color: Colors.LabelColor,
                                                  }}
                                              >
                                                  {key}:
                                              </span>
                                              <BasicText
                                                  className="text-sm font-medium"
                                                  text={formatCertificationDate(value)}
                                              />
                                          </Col>
                                      ))}
                            </Row>
                        </>
                    )}

                    {!hideEditButton && isRole !== 'supervisor' && isRole !== 'manager' ? (
                        <Row
                            className="w-full"
                            justify={'end'}
                            align={'middle'}
                        >
                            <Col span={6}>
                                <Button.Basic
                                    onClick={() => UserEditHandler()}
                                    style={{
                                        width: '100%',
                                        height: '40px',
                                        color: Colors.White,
                                        backgroundColor: colorPrimary,
                                    }}
                                    icon={<CiEdit size={18} />}
                                    className={
                                        'h-11 flex items-center justify-center outline-none border-0 rounded-none'
                                    }
                                    text={'Edit User'}
                                />
                            </Col>
                        </Row>
                    ) : (
                        <></>
                    )}
                </Row>
            )}
        </BasicDrawer>
    );
};

export default UserDetailDrawer;
